import EventEmitter from 'src/helpers/EventEmitter'
import { DEG_TO_RAD } from 'src/helpers/MathUtils'
import { frequencies } from 'src/helpers/WebAudio'
import store from '@/store'

import Bg from 'src/components/Stage/question/bg'
import ProcessingCircles from 'src/components/Stage/question/circles';
import TapholdLines from 'src/components/Stage/question/lines';
import Character from 'src/components/Stage/question/character';
import Bubbles from 'src/components/Stage/question/bubbles';
import TapHold from 'src/components/Stage/question/taphold';
import ResultFeedback from 'src/components/Stage/question/resultfeedback';
import Timer from 'src/components/Stage/question/timer'
import ResizeService from '@/services/ResizeService' 
const THREE = require('three')
 
class Questions extends THREE.Group { 

  constructor(config) {

    super();

    Object.assign(this, EventEmitter)

    this.STATES = store.state.question.STATES;
    this.state = null;

    this.setup();
    this.resize();
  }

  setup() {

    this.createMaterials();
 
    this.views = [
      new Bg(),
      new TapholdLines({
        materials: this.materials
      }),
      new ProcessingCircles({
        materials: this.materials
      }),
      new Character(),
      new Bubbles(),
      new TapHold(),
      new ResultFeedback()
    ];

    for (var i = 0; i < this.views.length; i++) {
      this.add(this.views[i]);
    }
  
    this.scale.x = this.scale.y = this.scale.z = 0.2;
    this.position.z = -900;
    this.position.y = -1100; 
  }

  createMaterials(){
     let images = [
      require('@/assets/img/explosion.png'), 
      require('@/assets/img/explosion_1.png'), 
      require('@/assets/img/explosion_2.png'), 
      require('@/assets/img/explosion_3.png')
    ]
    this.materials = [];
    for (var i = 0; i < images.length; i++) {
      let texture = new THREE.TextureLoader().load(images[i]) 
      texture.magFilter = THREE.NearestFilter;
      texture.minFilter = THREE.NearestFilter;
      texture.anisotropy = 0; 
      let material = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true
      })
      this.materials.push( material );
    }
  } 

  hide() {
    this.container.visible = false;
  }

   /* question state handlers */

  updateState(val) {
    switch(val) {
      case this.STATES.IDLE:
        this.idle();
        break;
      case this.STATES.TAP_HOLD_PROGRESS:
        this.tapholdProgress();
        break;
      case this.STATES.TAP_HOLD_RECORD:
        this.tapholdRecord();
        break; 
      case this.STATES.TAP_HOLD_RELEASE:
        this.tapholdRelease();
        break; 
      case this.STATES.PROCESSING:
        this.processing();
        break; 
      case this.STATES.COMPLETE:
        this.complete();
        break;
      case this.STATES.ERROR:
        this.error();
        break;
    } 
    
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].state = val; 
    }
  }

  idle() {
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].idle();
    }
  }

  tapholdProgress() {
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].tapholdProgress();
    }
  }
  
  tapholdRecord() {
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].tapholdRecord();
    }
  }

  tapholdRelease() {
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].tapholdRelease();
    }
  }
    
  processing() {
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].processing();
    }
  }
    
  complete() { 
    let index = store.state.question.result.index;
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].complete(index);
    }
  }

  result(val){ 
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].result(val);
    }
  }


 
  tick(tap_hold_ratio) { 
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].tick(tap_hold_ratio);
    }
  }

  updateRoute(val) {
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].updateRoute(val)
    }
  }
   
  resize = () => { }
  
 
 
}

export default Questions